import { rollup } from "d3-array";
import { TVehicle } from "types";

export const sortAsc = (a: any, b: any) => {
  return b.title > a.title ? -1 : 1;
};

export const getStatistics = (vehicles: TVehicle[]): Map<string, number> => {
  const result = rollup(
    vehicles,
    (v) => v.length,
    (d) => d.kraftstoff.id.toString()
  );
  return result;
};

type TOption = {
  value: string | number;
  title: string;
};

export const sortOptionsByFavourites = (
  favourites: (string | number)[] = [42]
) => {
  return (a: TOption, b: TOption) => {
    if (favourites) {
      if (favourites.includes(a.value)) {
        if (favourites.includes(b.value)) {
          return favourites.indexOf(a.value) < favourites.indexOf(b.value)
            ? -1
            : 1;
        }
        return -1;
      }
      if (favourites.includes(b.value)) {
        return 1;
      }
    }
    return b.title > a.title ? -1 : 1;
  };
};
